import React, { useState, useEffect } from 'react'
import { PostData, fetchData } from '../Services/httpHandelars'
import { useGlobalContext } from '../context'
import Loader from '../Components/Loader';
import Snackbar from '../Components/Snackbar';
import { useNavigate } from 'react-router-dom';
import MultiSelect from '../Components/MultiSelect';


export const QcReport = () => {


    const [form, setForm] = useState({ _id: "", assayName: "", controlName: {} })
    const [controlSetup, setControlSetup] = useState([])
    const [snacBar, setSnacBar] = useState({ snacStatus: false, message: "", snackType: "" })
    const [checkbox , setCheckBox]=useState({})
    const[tableData , setTableData]=useState([])

    const { setLoading, loading, setUser } = useGlobalContext();
    const navigate = useNavigate();

    useEffect(
        () => {
            if (snacBar.snacStatus === true) {
                setTimeout(() => setSnacBar(false), 3000);
            }
        },

        [snacBar.snacStatus]
    );


    useEffect(() => {
        fetchData("/api/getControlSetup").then((success) => {
            success = JSON.parse(success)
            if (!success.status && success.message.includes("jwt")) {
                setUser(null)
                navigate('/Login')
            }
            else if (success.status) {
                const control = success.data;
                setControlSetup(control);
            }
        })
    }, [])



    const HandleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value })
    }


  

    const handleSubmit = () => {
        setLoading(true)
        console.log('checkbox',Object.keys( checkbox))
        var checkedBoxKeys= Object.keys( checkbox)
        let checkboxesArray = checkedBoxKeys.filter((v)=>checkbox[v])
        let data ={
                performDate: form.startDate,
                controlID: checkboxesArray
            }

           
            PostData("/api/getQCReportData", data ).then((success) => {
                setLoading(false)
                
                if (success.status === true) {
                    console.log(success, "success")
                    setTableData(success.success)
                    console.log(tableData, "table Data")
                    setSnacBar({
                        ...snacBar,
                        snacStatus: success.status,
                        message: success.message,
                        snackType: "Success"
                    })
                } else {
                    setLoading(false)

                    setSnacBar({
                        ...snacBar,
                        snacStatus: success.status,
                        message: "Responce Failed",
                        snackType: "Error"
                    })
                }
         
            }).catch((err) => {
                setLoading(false)

                console.log("asd--->", err)
                setSnacBar({
                    ...snacBar,
                    snacStatus: true,
                    message: "Responce Failed",
                    snackType: "Error"
                })
            })
   


    }


    return (
        <>
            {!loading ? <>
                <div className='flex flex-col'>
                    <div className='grid justify-center flex font-medium py-4 text-gray-700'>
                        QC Report
                    </div>
                    <div className='h-16 min-h-min mt-5 '>
                        <div className='flex items-center justify-center px-4 py-10 sm:p-6'>
                            <div className="py-6 px-12 grid grid-cols-3 gap-4">
                                <div className="col-span-1">
                                    <label htmlFor="AssayName" className="block text-sm font-medium text-gray-700">
                                      Select Date
                                    </label>
                                    <div >

                                        <input name="startDate" type="date" onChange={HandleChange} className="block w-full h-12 px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" placeholder="Select date start" />
                                    </div>
                                </div>
                                <div className="col-span-1 ">
                                    <label htmlFor="AssayName" className="block text-sm font-medium text-gray-700">
                                        Controller Names
                                    </label>
                                 
                                    <MultiSelect value={controlSetup} id="_id" name="ControlName" checkbox={checkbox} setCheckBox={setCheckBox} /> 
                                </div>
                                <div className="col-span-1">
                                <div className=' flex mt-5 w-full '>
                                <button
                                    onClick={handleSubmit}
                                    type='submit'
                                    className='py-2 px-4 h-12   border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500'
                                >
                                    {form._id ? "Update" : "Search"}
                                </button>
                            </div>
                                </div>
                               
                            </div>
                        </div>
                    </div>

                    <div className='flex justify-center' style={{zIndex:"-10"}}>
                        <table className="w-9/12 text-sm text-center text-gray-500 dark:text-gray-400 mt-20">
                            <thead className="text-xs  text-gray-700 uppercase bg-gray-300 dark:bg-gray-700 dark:text-gray-400">
                                <tr className=''>
                                   

                                    <th rowSpan={2} scope="col" className="py-3 px-6 border border-solid ">
                                        Assay Name
                                    </th>
                                    <th rowSpan={2} scope="col" className="py-3 px-6 border border-solid ">
                                        Controller Name
                                    </th>
                                    <th scope="col" colSpan={2} className="py-3 px-100 border border-solid ">
                                            Range
                                    </th>
                                    <th rowSpan={2}  scope="col" className="py-3 px-6 border border-solid ">
                                        Result
                                    </th>
                                    <th rowSpan={2} scope="col" className="py-3 px-6 border border-solid ">
                                        Validity
                                    </th>
                                    
                                </tr>
                                <tr className=" ">                                
                                    <th scope="col" className="py-3 px-6 border border-solid ">
                                    Lower
                                    </th>
                                    <th scope="col" className="py-3 px-6 border border-solid ">
                                    Upper
                                    </th>                               
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    tableData?.map((tdata, i) => (
                                            tdata.report?.map((tSubData, j) => {
                                                return (

                                                    <tr className="bg-white border-b dark:border-gray-700 text-gray-700 font-medium h-12">
                                                       { j === 0 && 
                                                        <td className='px-6'rowSpan={tdata.report.length} >{tdata._id}</td>}
                                                        
                                                        <td className='px-6'>{tSubData.ControlName || '-'}</td>
                                                        <td className='px-6'>{tSubData.LowerRange || '-'}</td>
                                                        <td className='px-6'>{tSubData.UpperRange || '-'}</td>
                                                        <td className='px-6'>{tSubData.Result || '-'}</td>
                                                        {
                                                            (tSubData.UpperRange ? 
                                                                ((tSubData.Result > tSubData.UpperRange) ? <td className='px-6'>Fail</td> : <td className='px-6'>Pass</td>) : 
                                                                (tSubData.Result > tSubData.LowerRange) ? <td className='px-6'>Fail</td> : <td className='px-6'>Pass</td>)
                                                        }
                                                    </tr>
                                                )
                                            })
                                        
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {snacBar?.snacStatus &&
                    <Snackbar snackType={snacBar?.snackType} message={snacBar.message} status={snacBar?.snacStatus} setSnacBar={setSnacBar} />
                }
            </>
                : <Loader />
            }
        </>
    )
}
